import React, { createContext, useContext, useMemo } from 'react';
import { useAuth } from './AuthContext';

const AppContext = createContext(null);

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
};

export const AppProvider = ({ children }) => {
  const { user } = useAuth();
  
  const selectedOrg = useMemo(() => user ? {
    id: user.org_id,
    name: user.org_name || 'Organization'
  } : null, [user]);
  
  const selectedOutlet = user?.outlet_id || null;
  
  // Period lives in the shared URL-backed contract (hooks/usePeriod), not here.
  const value = useMemo(() => ({
    selectedOrg,
    selectedOutlet,
  }), [selectedOrg, selectedOutlet]);

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
